/* esm.sh - esbuild bundle(@lit/reactive-element@1.6.3/decorators/base) esnext production */
var p=(e,t,r)=>{Object.defineProperty(t,r,e)},y=(e,t)=>({kind:"method",placement:"prototype",key:t.key,descriptor:e}),s=({finisher:e,descriptor:t})=>(r,i)=>{var n;if(i===void 0){let o=(n=r.originalKey)!==null&&n!==void 0?n:r.key,d=t!=null?{kind:"method",placement:"prototype",key:o,descriptor:t(r.key)}:{...r,key:o};return e!=null&&(d.finisher=function(c){e(c,o)}),d}{let o=r.constructor;t!==void 0&&Object.defineProperty(r,i,t(i)),e?.(o,i)}};export{s as decorateProperty,p as legacyPrototypeMethod,y as standardPrototypeMethod};
/*! Bundled license information:

@lit/reactive-element/decorators/base.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
//# sourceMappingURL=base.js.map